import { css } from "../../../styled-system/css";

export const styles = {
  card: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile3",
      backgroundColor: "black",
      borderRadius: 0,
      padding: "baseUnit.mobile4",
      width: "100%",
      desktop: {
        borderRadius: "baseUnit.mobile4",
      },
    }),

  illustrationArea: () =>
    css({
      position: "relative",
      height: "baseUnit.mobile25",
      borderRadius: "4px",
      overflow: "hidden",
      background: "linear-gradient(90deg, rgba(126, 206, 244, 0.2) 0%, rgba(126, 206, 244, 0.2) 100%), white",
    }),

  illustrationImage: () =>
    css({
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      border: 0,
      display: "block",
      pointerEvents: "none",
      overflow: "hidden",
      mixBlendMode: "multiply",
    }),

  vinPill: () =>
    css({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "baseUnit.mobile1 baseUnit.mobile3",
      backgroundColor: "white",
      borderRadius: "4px",
      width: "100%",
      height: "36px",
    }),

  vinText: () =>
    css({
      fontSize: "body.mouse",
      fontWeight: 700,
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      color: "midnight",
      textAlign: "center",
    }),

  statsSection: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile2",
    }),

  statsHeading: () =>
    css({
      fontSize: "heading.H4.desktop",
      fontWeight: 800,
      lineHeight: "heading.H4.desktop",
      letterSpacing: "heading.H4.desktop",
      color: "white",
      margin: 0,
    }),

  statsList: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile1",
      listStyle: "none",
      padding: 0,
      margin: 0,
    }),

  statItem: () =>
    css({
      display: "flex",
      alignItems: "center",
      gap: "4px",
    }),

  statIcon: () =>
    css({
      width: "24px",
      height: "24px",
      flexShrink: 0,
      opacity: 0,
      animationName: "fadeIn",
      animationDuration: "400ms",
      animationTimingFunction: "ease-out",
      animationFillMode: "forwards",
      animationDelay: "calc(1500ms + var(--stat-index) * (1500ms / var(--stat-count)))",
      "@media (prefers-reduced-motion: reduce)": {
        opacity: 1,
        animation: "none",
      },
    }),

  statText: () =>
    css({
      fontSize: "body.mouse",
      fontWeight: 400,
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      color: "white",
      opacity: 0,
      animationName: "fadeIn",
      animationDuration: "400ms",
      animationTimingFunction: "ease-out",
      animationFillMode: "forwards",
      animationDelay: "calc(var(--stat-index) * (1500ms / var(--stat-count)))",
      "@media (prefers-reduced-motion: reduce)": {
        opacity: 1,
        animation: "none",
      },
    }),
};
